export var Stardust = {
  chainId: 588,
  chainName: 'Stardust',
  isTestChain: true,
  isLocalChain: false,
  multicallAddress: '0xaF9D4DC0698d8FD9f41387ecb08D9976079B8086',
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://stardust-explorer.metis.io/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://stardust-explorer.metis.io/".concat(transactionHash);
  }
};
export default {
  Stardust: Stardust
};